import chunk from 'lodash/chunk';
import { GTM_BANNER_COMPONENT_POSITION_CLASS_NAME } from './gtmConstants';
import { sendClickOrImpressionTrackerToJioAds, checkBannerImpressionPromoId, setBannerImpressionPromoId, getBundleBannerImpressionArray, setBundleBannerImpressionArray, emptyBundleBannerImpressionArray } from '../../utils/jioAdsRelated';
import { fireOsmosPlpImpression } from '../../utils/osmosPlpImpressionUtils';
import _isEmpty from 'lodash/isEmpty';
import UTILS from '../../utils/jioAdsUtils';

const objectToString = Object.prototype.toString;
const bnrPositionClassNamePatrn = new RegExp(`(${GTM_BANNER_COMPONENT_POSITION_CLASS_NAME})`, 'i');
const INCLUDE_BANNER_ROOT_PROPERTIES = [
  'pageTitle',
  'seoTitle',
  'seoDescription',
  'seoKeyword',
  'banner',
  'bannerImageDetails',
  'title',
  'leftBanner',
  'middleBanner',
  'rightBanner',
  'typeCode'
];
const INCLUDE_BANNER_PROPERTIES = [
  'componentPosition',
  'imageUrl',
  'uId'
];
const jioAdsBannerPromoIdDataListWeb = "jioAdsBannerPromoIdDataListWeb";
const jioAdsBannerPromoIdDataListMsite = "jioAdsBannerPromoIdDataListMsite";
const bannerImpressionPromoIdDataListWeb = "bannerImpressionPromoIdDataListWeb";
const bannerImpressionPromoIdDataListMsite = "bannerImpressionPromoIdDataListMsite";
const bundleBannerImpressionPromoIdDataListWeb = "bundleBannerImpressionPromoIdDataListWeb";
const bundleBannerImpressionPromoIdDataListMsite = "bundleBannerImpressionPromoIdDataListMsite";
function extractProperties(argPropsList = [], argObj = {}) {
  const propsList = argPropsList ? argPropsList : [];
  const obj = argObj ? argObj : {};
  let data = {};
  propsList.forEach(ele => {
    data[ele] = obj[ele];
  });
  return JSON.parse(JSON.stringify(data));
}
function getComponentPositionFromClassName(classList = []) {
  const classes = Array.prototype.slice.call(classList);
  let bnrPositionClassIndex = classes.findIndex(
    ele => ele.search(bnrPositionClassNamePatrn) !== -1
  );
  return bnrPositionClassIndex >= 0
    ? classes[bnrPositionClassIndex].split(GTM_BANNER_COMPONENT_POSITION_CLASS_NAME)[1]
    : '';
}
function getUniqueListBy(arr, key) {
  return [...new Map(arr.map(item => [item[key], item])).values()]
}
function setNewBanners(newBanners, oldBanners) {
  let uniqueBanners = getUniqueListBy(newBanners, 'id');
  let lastPosition = oldBanners ? oldBanners.length + 1 : 1;
  return uniqueBanners.reduce((acc, banner) => {
    if(!oldBanners.includes(banner.id)){
      banner.position = lastPosition;
      acc.push(banner);
      lastPosition = lastPosition + 1;
    }
    return acc;
  }, []);
}
function setBannersToOld(newBanners) {
  return newBanners.map(banner => banner.id);
}
export function getImageNameForGTMPromotion(imageUrl) {
  if (objectToString.call(imageUrl) === '[object String]' && imageUrl.length) {
    let startIndex = imageUrl.lastIndexOf('/');
    let lastIndex = imageUrl.indexOf('.', startIndex);
    startIndex = startIndex === -1 ? 0 : startIndex + 1;
    lastIndex = lastIndex === -1 ? imageUrl.length : lastIndex;
    lastIndex = imageUrl.length;
    return imageUrl.substring(startIndex, lastIndex);
  }
  return '';
}
export function extractBannerDataForGTMPromotion(data = [], classList = []) {
  const bnrCompPositionIndex = getComponentPositionFromClassName(classList);
  if (bnrCompPositionIndex !== '') {
    return data.reduce((acc, banner) => {
      if (banner.componentPosition === Number(bnrCompPositionIndex)) {
        const { uId = '', imageUrl = '', componentPosition = '' } = banner;
        let pushData = {
          id: uId,
          name: getImageNameForGTMPromotion(imageUrl),
          position: componentPosition
        }
        acc.push(pushData);
      }
      return acc;
    }, []);
  }
  return [];
}
export function triggerLandingPageGtmMetaEvent(props, gtmExtraInfoMeta) {
  const { banner: { pageDetails = [] } = {} } = props;
  let gtmBannersData = [];
  if (objectToString.call(pageDetails) === '[object Array]' && pageDetails.length) {
    let result = pageDetails.reduce((acc, obj) => {
      const { typeCode = '' } = obj;
      if (
        !typeCode ||
        (typeCode.search(/NativeSpacing/i) === -1 && typeCode.search(/NewTitleComponent/i) === -1)
      ) {
        acc.push(extractProperties(INCLUDE_BANNER_ROOT_PROPERTIES, obj));
      }
      return acc;
    }, []);
    if (result.length) {
      const optmizedResult = JSON.parse(JSON.stringify(result));
      for (let p = 0; p < optmizedResult.length; p++) {
        if (optmizedResult[p].banner) {
          let data = extractProperties(INCLUDE_BANNER_PROPERTIES, optmizedResult[p].banner);
          optmizedResult[p].banner = { ...data };
          gtmBannersData.push({ ...data });
        } else if (
          optmizedResult[p].leftBanner ||
          optmizedResult[p].middleBanner ||
          optmizedResult[p].rightBanner
        ) {
          let data;
          if(optmizedResult[p].leftBanner) {
            data = extractProperties(INCLUDE_BANNER_PROPERTIES, optmizedResult[p].leftBanner);
            optmizedResult[p].leftBanner = { ...data };
            gtmBannersData.push({ ...data });
          }
          if(optmizedResult[p].middleBanner) {
            data = extractProperties(INCLUDE_BANNER_PROPERTIES, optmizedResult[p].middleBanner);
            optmizedResult[p].middleBanner = { ...data };
            gtmBannersData.push({ ...data });
          }
          if(optmizedResult[p].rightBanner) {
            data = extractProperties(INCLUDE_BANNER_PROPERTIES, optmizedResult[p].rightBanner);
            optmizedResult[p].rightBanner = { ...data };
            gtmBannersData.push({ ...data });
          }
        } else if (optmizedResult[p].bannerImageDetails) {
          let banners = [];
          optmizedResult[p].bannerImageDetails.forEach(obj => {
            let data = extractProperties(INCLUDE_BANNER_PROPERTIES, obj);
            banners.push({ ...data });
            gtmBannersData.push({ ...data });
          });
          optmizedResult[p].bannerImageDetails = banners;
        }
      }
      gtmExtraInfoMeta('landingPageMetaData', optmizedResult);
      return gtmBannersData;
    }
    return gtmBannersData;
  }
  return gtmBannersData;
}
export function createGTMBannerViewPortIntersectionObserverDesktop(
  gtmBannersData,
  bannersHTMLElements,
  gtmPromotionImpressions,
  gtmBannersImpressionData,
  newDesignLuxe,
) {
  const observerOptions = {
    root: null,
    rootMargin: '0px',
    threshold: 0.45
  };
  const callback = entries => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        const classList = entry.target.classList || [];
        const gtmPromoImpressionData = extractBannerDataForGTMPromotion(gtmBannersData, classList);
        gtmPromotionImpressions(gtmPromoImpressionData);
      }
    });
  };
  const gtmBannerViewportObserver = new IntersectionObserver(callback, observerOptions);
  const gtmLuxeBannerViewportObserver = new IntersectionObserver(entries => {
    entries.forEach((entry, idx) => {
      if (entry.isIntersecting) {
        const classList = entry.target.classList || [];
        const gtmPromoImpressionData = extractBannerDataForGTMPromotion(gtmBannersData, classList);
        const newBannerData = setNewBanners(gtmPromoImpressionData, gtmBannersImpressionData.oldBanners);
        if(newBannerData.length > 0){
          const updateOldData = setBannersToOld(newBannerData);
          gtmBannersImpressionData.oldBanners = gtmBannersImpressionData.oldBanners.concat(updateOldData);
          gtmBannersImpressionData.banners = [
            ...gtmBannersImpressionData.banners,
            ...newBannerData
          ];
          const gtmBannersImpressionDataChunks = chunk(gtmBannersImpressionData.banners, 10);
          gtmBannersImpressionData.banners = gtmBannersImpressionDataChunks.reduce(
            (acc, chunkArr) => {
              if (chunkArr.length === 10) {
                gtmPromotionImpressions(chunkArr);
              } else {
                acc = Array.isArray(chunkArr) ? chunkArr : [];
              }
              return acc;
            },
            []
          );
          gtmBannersImpressionData.lastPushedAt = gtmBannersImpressionData.banners.at(-1).position;
        }
      }
    });
  }, observerOptions);
  if(newDesignLuxe) {
    bannersHTMLElements.forEach(HTMLElement => gtmLuxeBannerViewportObserver.observe(HTMLElement));
    return gtmLuxeBannerViewportObserver;
  } else {
    bannersHTMLElements.forEach(HTMLElement => gtmBannerViewportObserver.observe(HTMLElement));
    return gtmBannerViewportObserver;
  }
}
export function createCmsGTMBannerViewPortIntersectionObserverDesktop(
  bannersHTMLElements,
  gtmPromotionImpressions,
  newDesignLuxe,
  storeType,
  pageName,
  pageType
) {
  const observerOptions = {
    root: null,
    rootMargin: '0px',
    threshold: 0.45
  };
  const callbackInnerDesktop = entries => {
    let promotionArray = getBundleBannerImpressionArray(bundleBannerImpressionPromoIdDataListWeb);
    let entry = entries?.length ? entries[0] : {};
    if (entry?.isIntersecting) {
      let element = entry.target;
      let promoPosition = element.getAttribute('data-gtm-bnr-position');
      let promoID = element.getAttribute('data-gtm-bnr-id');
      let promoName = element.getAttribute('data-gtm-bnr-imgname');
      let promoWidth = element.getAttribute('data-gtm-bnr-width')
      let promoHeight = element.getAttribute('data-gtm-bnr-height');
      let isJioAds = element.getAttribute('data-gtm-bnr-isjioads')
      let  jioAdsImpression = element.getAttribute('data-gtm-bnr-jioads-impression');
      let cid = element.getAttribute('data-gtm-bnr-jioads-cid')
      let jioAdsBannerName = element.getAttribute('data-gtm-bnr-jioads-desc');
      const sclId = element.getAttribute('data-gtm-bnr-sclid');
      const uclId = element.getAttribute('data-gtm-bnr-uclid');
      const clientId = element.getAttribute('data-gtm-bnr-clientid');
      const bannertype = element.getAttribute('data-ga-event-category');
      const bannerName = element.getAttribute('data-gtm-bnr-imgname');

      let isCidPresent = true

      if (promoPosition) { 
        let promoCreativeName = null
        if (promoWidth && promoHeight && parseInt(promoWidth) !== 0 && parseInt(promoHeight) !== 0) {
          promoCreativeName = `${promoWidth}x${promoHeight}`
        }
        if(isJioAds === 'true')
        {
          let jioAdsId = cid.substring(0, cid.lastIndexOf("_") + 1);
            isCidPresent = !promotionArray.find(promotion => {
            let promotionId = promotion?.id?.substring(0, promotion?.id?.lastIndexOf("_") + 1)
            if(promotionId === jioAdsId)
            {
              return true
            }
            return false
          });
        }
        const ccb = UTILS.getCCB(jioAdsBannerName);
      
        let promotionObj={};
        if(isCidPresent)
        {
          const ad_source = bannertype === 'EXTERNAL_AD' ? 'osmos' : isJioAds === 'true' ? 'jioads' : 'noads'
            promotionObj = {
            id:  isJioAds === 'true' ? cid.replaceAll('[ccb]', ccb) : promoID,
            name: bannertype === 'EXTERNAL_AD' ? `osmos - ${bannerName}` : isJioAds === 'true' ? `jioads - ${jioAdsBannerName}` : promoName,
            creative: promoCreativeName,
            position: promoPosition,
            sclid: sclId,
            uclid: uclId,
            clientId: clientId,
            adSource: ad_source
          }
        }
        if (!_isEmpty(promotionObj)) {
          const isPromoIdExistsForImpression = checkBannerImpressionPromoId(promoID, bannerImpressionPromoIdDataListWeb);
          if(!isPromoIdExistsForImpression){
            // Fire osmos impression tracker - only when promo ID exists and has not been tracked yet
            fireOsmosPlpImpression({
              uclid: uclId,
              position: promoPosition,
              page: 'HOME',
              clientId: clientId
            });
            console.log("TRACK BANNER IMPRESSION PROMOTION DATA ~ isPromoIdExistsForImpression:", promoID)
            promotionArray.push(promotionObj);
            console.log("TRACK BUNDLE BANNER IMPRESSION PROMOTION DATA ~ callbackInnerDesktop ~ promotionArray:", promotionArray)
            setBundleBannerImpressionArray(bundleBannerImpressionPromoIdDataListWeb, promotionArray, {storeType, pageName, pageType});
            if(promotionArray.length === 5){
              console.log("IMPRESSION FIRED BULK OF 5 ITEMS WEB..............")
              gtmPromotionImpressions(promotionArray, storeType, pageName, pageType)
              emptyBundleBannerImpressionArray(bundleBannerImpressionPromoIdDataListWeb);
            }
            setBannerImpressionPromoId(promoID, bannerImpressionPromoIdDataListWeb)  
          }            
        }
        if(!_isEmpty(jioAdsImpression)) {
          const isPromoIdExists = checkBannerImpressionPromoId(promoID, jioAdsBannerPromoIdDataListWeb);
          if(!isPromoIdExists){
            console.log("TRACK JIO ADS IMPRESSION PROMOTION DATA PUSHED", jioAdsImpression)
            sendClickOrImpressionTrackerToJioAds(jioAdsImpression, { jioAdsBannerName });
            setBannerImpressionPromoId(promoID, jioAdsBannerPromoIdDataListWeb)
          }
        }
      }
    }
  }
  const callback = entries => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        let observeredElement = entry.target
        let targetChildList = observeredElement.querySelectorAll("A")
        targetChildList.forEach(element => {
          const gtmCmsBannerViewportInnerObserverDesktop = new IntersectionObserver(callbackInnerDesktop, observerOptions);
          gtmCmsBannerViewportInnerObserverDesktop.observe(element);
        });
      }
    });
  };
  const gtmCmsBannerViewportObserver = new IntersectionObserver(callback, observerOptions);
  const gtmCmsLuxeBannerViewportObserver = new IntersectionObserver(callback, observerOptions);
  if(newDesignLuxe) {
    bannersHTMLElements.forEach(HTMLElement => gtmCmsLuxeBannerViewportObserver.observe(HTMLElement));
    return gtmCmsLuxeBannerViewportObserver;
  } else {
    bannersHTMLElements.forEach(HTMLElement => gtmCmsBannerViewportObserver.observe(HTMLElement));
    return gtmCmsBannerViewportObserver;
  }
}
export function createGTMBannerViewPortIntersectionObserver(
  gtmBannersData,
  bannersHTMLElements,
  gtmPromotionImpressions,
  gtmBannersImpressionData,
  luxe
) {
  const observerOptions = {
    root: null,
    rootMargin: '0px',
    threshold: 0.45
  };
  const gtmBannerViewportObserver = new IntersectionObserver(entries => {
    entries.forEach((entry, idx) => {
      if (entry.isIntersecting && idx > gtmBannersImpressionData.lastPushedAt) {
        const classList = entry.target.classList || [];
        const gtmPromoImpressionData = extractBannerDataForGTMPromotion(gtmBannersData, classList);
        gtmBannersImpressionData.banners = [
          ...gtmBannersImpressionData.banners,
          ...gtmPromoImpressionData
        ];
        const gtmBannersImpressionDataChunks = chunk(gtmBannersImpressionData.banners, 15);
        gtmBannersImpressionData.banners = gtmBannersImpressionDataChunks.reduce(
          (acc, chunkArr) => {
            if (chunkArr.length === 15) {
              gtmPromotionImpressions(chunkArr);
            } else {
              acc = Array.isArray(chunkArr) ? chunkArr : [];
            }
            return acc;
          },
          []
        );
        gtmBannersImpressionData.lastPushedAt = idx;
      }
    });
  }, observerOptions);
  const gtmLuxeBannerViewportObserver = new IntersectionObserver(entries => {
    entries.forEach((entry, idx) => {
      if (entry.isIntersecting) {
        const classList = entry.target.classList || [];
        const gtmPromoImpressionData = extractBannerDataForGTMPromotion(gtmBannersData, classList);
        const newBannerData = setNewBanners(gtmPromoImpressionData, gtmBannersImpressionData.oldBanners);
        if(newBannerData.length > 0){
          const updateOldData = setBannersToOld(newBannerData);
          gtmBannersImpressionData.oldBanners = gtmBannersImpressionData.oldBanners.concat(updateOldData);
          gtmBannersImpressionData.banners = [
            ...gtmBannersImpressionData.banners,
            ...gtmPromoImpressionData
          ];
          const gtmBannersImpressionDataChunks = chunk(gtmBannersImpressionData.banners, 10);
          gtmBannersImpressionData.banners = gtmBannersImpressionDataChunks.reduce(
            (acc, chunkArr) => {
              if (chunkArr.length === 10) {
                gtmPromotionImpressions(chunkArr);
              } else {
                acc = Array.isArray(chunkArr) ? chunkArr : [];
              }
              return acc;
            },
            []
          );
          gtmBannersImpressionData.lastPushedAt = gtmBannersImpressionData.banners.at(-1).position;
        }
      }
    });
  }, observerOptions);
  if(luxe) {
    bannersHTMLElements.forEach(HTMLElement => gtmLuxeBannerViewportObserver.observe(HTMLElement));
    return gtmLuxeBannerViewportObserver;
  } else {
    bannersHTMLElements.forEach(HTMLElement => gtmBannerViewportObserver.observe(HTMLElement));
    return gtmBannerViewportObserver;
  }
}
export function createCmsGTMBannerViewPortIntersectionObserver(
  bannersHTMLElements,
  gtmPromotionImpressions,
  luxe,
  storeType,
  pageName,
  pageType
) {
  const observerOptions = {
    root: null,
    rootMargin: '0px',
    threshold: 0.45
  };
  const callbackInnerMsite = entries => {
    let promotionArray = getBundleBannerImpressionArray(bundleBannerImpressionPromoIdDataListMsite);
    let entry = entries?.length ? entries[0] : {};
    if (entry?.isIntersecting) {
      let element = entry.target;
      let promoPosition = element.getAttribute('data-gtm-bnr-position');
      let promoID = element.getAttribute('data-gtm-bnr-id');
      let promoName = element.getAttribute('data-gtm-bnr-imgname');
      let promoWidth = element.getAttribute('data-gtm-bnr-width')
      let promoHeight = element.getAttribute('data-gtm-bnr-height');
      let jioAdsImpression = element.getAttribute('data-gtm-bnr-jioads-impression');
      let jioAdsBannerName = element.getAttribute('data-gtm-bnr-jioads-desc')
      let isJioAds = element.getAttribute('data-gtm-bnr-isjioads')
      let isPDBanner = element.getAttribute('data-gtm-bnr-isPDBanner')
      let cid = element.getAttribute('data-gtm-bnr-jioads-cid');
      const sclId = element.getAttribute('data-gtm-bnr-sclid');
      const uclId = element.getAttribute('data-gtm-bnr-uclid');
      const subscriptionDetails = element.getAttribute('data-gtm-bnr-subscription-details');
      const clientId = element.getAttribute('data-gtm-bnr-clientid');
      const bannertype = element.getAttribute('data-ga-event-category');
      const bannerName = element.getAttribute('data-gtm-bnr-imgname');
      let isCidPresent = true
      if (promoPosition) { 
        let promoCreativeName = null
        if (promoWidth && promoHeight && parseInt(promoWidth) !== 0 && parseInt(promoHeight) !== 0) {
          promoCreativeName = `${promoWidth}x${promoHeight}`
        }
        if(isJioAds === 'true')
        {
          let jioAdsId = cid.substring(0, cid.lastIndexOf("_") + 1);
            isCidPresent = !promotionArray.find(promotion => {
            let promotionId = promotion?.id?.substring(0, promotion?.id?.lastIndexOf("_") + 1)
            if(promotionId === jioAdsId)
            {
              return true
            }
            return false
          });
        }
        const ccb = UTILS.getCCB(jioAdsBannerName);
      
        let promotionObj={};
        if(isCidPresent)
        {
            const ad_source = bannertype === 'EXTERNAL_AD' ? 'osmos' : isJioAds === 'true' ? 'jioads' : 'noads';
            promotionObj = {
            id:  isJioAds === 'true' ? cid.replaceAll('[ccb]', ccb) : promoID,
            name: bannertype === 'EXTERNAL_AD' ? `osmos - ${bannerName}` :  isJioAds === 'true' ? `jioads - ${jioAdsBannerName}` : isPDBanner === 'true' ? `priority - ${promoName}` : promoName,
            creative: promoCreativeName,
            position: promoPosition,
            subscriptionDetails,
            sclid: sclId,
            uclid: uclId,
            clientId: clientId,
            adSource: ad_source
          }
        }
        if (!_isEmpty(promotionObj)) {
          const isPromoIdExistsForImpression = checkBannerImpressionPromoId(promoID, bannerImpressionPromoIdDataListMsite);
          if(!isPromoIdExistsForImpression){
            // Fire osmos impression tracker - only when promo ID exists and has not been tracked yet
            fireOsmosPlpImpression({
              uclid: uclId,
              position: promoPosition,
              page: 'HOME',
              clientId: clientId
            });
            console.log("TRACK BANNER IMPRESSION PROMOTION DATA Msite ~ isPromoIdExistsForImpression:", promoID)
            promotionArray.push(promotionObj)
            console.log("TRACK BUNDLE BANNER IMPRESSION PROMOTION DATA Msite ~ callbackInnerMsite ~ promotionArray:", promotionArray)
            setBundleBannerImpressionArray(bundleBannerImpressionPromoIdDataListMsite, promotionArray, {storeType, pageName, pageType});
            if(promotionArray.length === 5){
              console.log("IMPRESSION FIRED BULK OF 5 ITEMS MSITE..............")
              gtmPromotionImpressions(promotionArray, storeType, pageName, pageType)
              emptyBundleBannerImpressionArray(bundleBannerImpressionPromoIdDataListMsite);
            }
            setBannerImpressionPromoId(promoID, bannerImpressionPromoIdDataListMsite)  
          }            
        }
        if(!_isEmpty(jioAdsImpression)) {
          const isPromoIdExists = checkBannerImpressionPromoId(promoID, jioAdsBannerPromoIdDataListMsite);
          if(!isPromoIdExists){
            console.log("TRACK JIO ADS IMPRESSION PROMOTION DATA PUSHED Msite", jioAdsImpression)
            sendClickOrImpressionTrackerToJioAds(jioAdsImpression, { jioAdsBannerName });
            setBannerImpressionPromoId(promoID, jioAdsBannerPromoIdDataListMsite)
          }
        }
      }
    }
  }
  const callback = entries => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        let observeredElement = entry.target
        let targetChildList = observeredElement.querySelectorAll("A")
        
        targetChildList.forEach(element => {
          const gtmCmsBannerViewportInnerObserverMsite = new IntersectionObserver(callbackInnerMsite, observerOptions);
          gtmCmsBannerViewportInnerObserverMsite.observe(element);
        });
      }
    });
  };
  const gtmCmsBannerViewportObserver = new IntersectionObserver(callback, observerOptions);
  const gtmCmsLuxeBannerViewportObserver = new IntersectionObserver(callback, observerOptions);
  if(luxe) {
    bannersHTMLElements.forEach(HTMLElement => gtmCmsLuxeBannerViewportObserver.observe(HTMLElement));
    return gtmCmsLuxeBannerViewportObserver;
  } else {
    bannersHTMLElements.forEach(HTMLElement => gtmCmsBannerViewportObserver.observe(HTMLElement));
    return gtmCmsBannerViewportObserver;
  }
}
export function getBannerComponentPosition(obj = {}, prop = '') {
  let position = '';
  switch(prop) {
    case 'banner' : 
    case 'leftBanner' : 
      position = (obj[prop]?obj[prop].componentPosition || '' : '');
      break;
    case 'bannerImageDetails' :
      const bimageDetails = obj[prop] || [];
      for(let p = 0; p < bimageDetails.length; p++) {
        const comPosition = bimageDetails[p].componentPosition
        if(comPosition !== undefined) {
          position = comPosition;
          break;
        }
      }
      break;
    default: return '';
  }
  return (position === '' || position === undefined || position === null)? '' : position;
}